import axios from "../../../util/axios";

export default {
    /** 商品属性列表 */
    queryAttributeList: (searchInfo) => axios.get({url: "/order/product/attribute/queryAttributeList", data: searchInfo}),
    /** 保存属性 */
    saveAttribute: (data) => axios.post({url: "/order/product/attribute/saveAttribute", data: data}),
    /** 删除商品属性 */
    deleteAttribute: (id) => axios.del({url: "/order/product/attribute/deleteAttribute", data: {id}}),
}